export default {
  title: 'Notifications',
  center: 'Notification Center',
  markAllRead: 'Mark all read',
  markAllAsRead: 'Mark all as read',
  markRead: 'Read',
  noNotification: 'No notifications',
  unread: 'Unread',
  viewAll: 'View all notifications',
  allTitle: 'All Notifications',
  loadMore: 'Load more',
  newNotification: 'New notification',
  allMarkedRead: 'All marked as read',
  disablePopup: 'Disable popups',
  enablePopup: 'Enable popups',
  popupDisabled: 'New notifications will only update the badge',
  popupEnabled: 'New notification popups enabled',
  orderMatched: 'Order matched',
  orderLocked: 'Order locked',
  orderUnlocked: 'Order unlocked',
}
